import { Auditable, QueryParams, SortParams } from "..";

export interface AccountCreditEntry extends Auditable {
    accountId: number;
    invoiceId?: number;
    amount: number;
    note?: string;
}

export const DefaultAccountCreditEntryQueryParams: QueryParams = {
    accountId: "",
};

export const DefaultAccountCreditEntrySortParams: SortParams = {
    orderBy: "createdOn",
    orderDesc: "true",
};
